export default __webpack_public_path__ + "static/home1-667ad65470ff5af4acd3ee1382a7d5a6.webm";